import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguageService } from 'src/app/shared/services/language.service';
import { UiService } from 'src/app/shared/services/ui.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-language-wrapper',
    templateUrl: './language-wrapper.component.html',
    styleUrls: ['./language-wrapper.component.scss']
})
export class LanguageWrapperComponent implements OnInit, OnDestroy {
    private subscription = new Subscription();

    langFromUrl: string;
    constructor(
        private route: ActivatedRoute,
        private languageSrv: LanguageService,
        private router: Router,
        private uiSrv: UiService
    ) { }

    ngOnInit() {
        this.getRouteData();
        this.initSubscriptions();
    }

    private getRouteData(): void {
        this.langFromUrl = this.route.snapshot.paramMap.get('lang');
        if(this.langFromUrl) {
            this.languageSrv.setCurrentLanguage(this.langFromUrl)
            .subscribe(() => {
                this.uiSrv.translationLoadingStateChanged.next(false);
            });
        } else {
            this.router.navigate(['/fr']);
        }
    }

    private initSubscriptions(): void {
        this.subscription.add(
            this.languageSrv.languageChanged
            .subscribe(newLang => {
                if(newLang !== this.langFromUrl) {
                    this.langFromUrl = newLang;
                    this.router.navigate([`/${newLang}`]);
                }
            })
        );
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
